//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns a list of all roles with permissions
 */
export function getGeneralRoles(config?: AxiosRequestConfig | undefined): Promise<Types.RoleDto[]> {
    let url_ = getBaseUrl() + "/api/roles";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetGeneralRoles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetGeneralRoles(_response);
    });
}

function processGetGeneralRoles(response: AxiosResponse): Promise<Types.RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.RoleDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.RoleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RoleDto[]>(null as any);
}

/**
 * Create a new role
 * @param dto Creation role DTO
 * @return New role Id
 */
export function createRole(dto: Types.RoleCreationDto, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/roles";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateRole,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateRole(_response);
    });
}

function processCreateRole(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * Returns a list of all study roles with claims
 * @param studyId (optional) 
 * @param includeForms (optional) 
 */
export function getStudyRoles(studyId?: number | null | undefined, includeForms?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StudyRoleDto[]> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles?";
    if (studyId !== undefined && studyId !== null)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (includeForms !== undefined && includeForms !== null)
        url_ += "includeForms=" + encodeURIComponent("" + includeForms) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyRoles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyRoles(_response);
    });
}

function processGetStudyRoles(response: AxiosResponse): Promise<Types.StudyRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyRoleDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyRoleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyRoleDto[]>(null as any);
}

/**
 * Create a new study role
 * @param dto Creation role DTO
 */
export function createStudyRole(dto: Types.StudyRoleCreationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateStudyRole,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateStudyRole(_response);
    });
}

function processCreateStudyRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add claims to the study role
 * @param roleId Study Role Id to add new claims
 * @param claims Claims to add
 */
export function addStudyClaimsToRole(roleId: string, claims: Types.StudyRoleClaimValue[], config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/claims/add";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(claims);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddStudyClaimsToRole,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddStudyClaimsToRole(_response);
    });
}

function processAddStudyClaimsToRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Make form config available to role
 * @param roleId Role Id to add new forms
 * @param formConfigId (optional) Form config id to make available
 */
export function makeFormAvailableToRole(roleId: string, formConfigId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/availableForms/add?";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    if (formConfigId === null)
        throw new Error("The parameter 'formConfigId' cannot be null.");
    else if (formConfigId !== undefined)
        url_ += "formConfigId=" + encodeURIComponent("" + formConfigId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMakeFormAvailableToRole,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMakeFormAvailableToRole(_response);
    });
}

function processMakeFormAvailableToRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Make form config unavailable to role
 * @param roleId Role Id to add new forms
 * @param formConfigId (optional) Form config id to make unavailable
 */
export function makeFormUnavailableToRole(roleId: string, formConfigId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/availableForms/remove?";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    if (formConfigId === null)
        throw new Error("The parameter 'formConfigId' cannot be null.");
    else if (formConfigId !== undefined)
        url_ += "formConfigId=" + encodeURIComponent("" + formConfigId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMakeFormUnavailableToRole,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMakeFormUnavailableToRole(_response);
    });
}

function processMakeFormUnavailableToRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Remove study role
 * @param id Id of the role to be removed
 */
export function removeStudyRole(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveStudyRole,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveStudyRole(_response);
    });
}

function processRemoveStudyRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Remove claims from the study role
 * @param roleId Study Role Id to remove new claims
 * @param claims Claims to add
 */
export function removeStudyClaimsFromRole(roleId: string, claims: Types.StudyRoleClaimValue[], config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/claims/remove";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(claims);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveStudyClaimsFromRole,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveStudyClaimsFromRole(_response);
    });
}

function processRemoveStudyClaimsFromRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Remove role
 * @param id Id of the role to be removed
 */
export function removeRole(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveRole,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveRole(_response);
    });
}

function processRemoveRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Add permission to the role
 * @param roleId Role Id to add new permission
 * @param permission (optional) Permission to add
 */
export function addPermission(roleId: string, permission?: Types.Permissions | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/permissions/{roleId}/add?";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    if (permission === null)
        throw new Error("The parameter 'permission' cannot be null.");
    else if (permission !== undefined)
        url_ += "permission=" + encodeURIComponent("" + permission) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddPermission,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddPermission(_response);
    });
}

function processAddPermission(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Remove permission from the role
 * @param roleId Role Id to remove the permission
 * @param permission (optional) Permission to remove
 */
export function removePermission(roleId: string, permission?: Types.Permissions | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/permissions/{roleId}/remove?";
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
    if (permission === null)
        throw new Error("The parameter 'permission' cannot be null.");
    else if (permission !== undefined)
        url_ += "permission=" + encodeURIComponent("" + permission) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemovePermission,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemovePermission(_response);
    });
}

function processRemovePermission(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetGeneralRoles: Partial<AxiosRequestConfig> | null;
export function getGetGeneralRolesRequestConfig() {
  return _requestConfigGetGeneralRoles;
}
export function setGetGeneralRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetGeneralRoles = value;
}
export function patchGetGeneralRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetGeneralRoles = patch(_requestConfigGetGeneralRoles ?? {});
}

let _requestConfigCreateRole: Partial<AxiosRequestConfig> | null;
export function getCreateRoleRequestConfig() {
  return _requestConfigCreateRole;
}
export function setCreateRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateRole = value;
}
export function patchCreateRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateRole = patch(_requestConfigCreateRole ?? {});
}

let _requestConfigGetStudyRoles: Partial<AxiosRequestConfig> | null;
export function getGetStudyRolesRequestConfig() {
  return _requestConfigGetStudyRoles;
}
export function setGetStudyRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyRoles = value;
}
export function patchGetStudyRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyRoles = patch(_requestConfigGetStudyRoles ?? {});
}

let _requestConfigCreateStudyRole: Partial<AxiosRequestConfig> | null;
export function getCreateStudyRoleRequestConfig() {
  return _requestConfigCreateStudyRole;
}
export function setCreateStudyRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyRole = value;
}
export function patchCreateStudyRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyRole = patch(_requestConfigCreateStudyRole ?? {});
}

let _requestConfigAddStudyClaimsToRole: Partial<AxiosRequestConfig> | null;
export function getAddStudyClaimsToRoleRequestConfig() {
  return _requestConfigAddStudyClaimsToRole;
}
export function setAddStudyClaimsToRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddStudyClaimsToRole = value;
}
export function patchAddStudyClaimsToRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddStudyClaimsToRole = patch(_requestConfigAddStudyClaimsToRole ?? {});
}

let _requestConfigMakeFormAvailableToRole: Partial<AxiosRequestConfig> | null;
export function getMakeFormAvailableToRoleRequestConfig() {
  return _requestConfigMakeFormAvailableToRole;
}
export function setMakeFormAvailableToRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMakeFormAvailableToRole = value;
}
export function patchMakeFormAvailableToRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMakeFormAvailableToRole = patch(_requestConfigMakeFormAvailableToRole ?? {});
}

let _requestConfigMakeFormUnavailableToRole: Partial<AxiosRequestConfig> | null;
export function getMakeFormUnavailableToRoleRequestConfig() {
  return _requestConfigMakeFormUnavailableToRole;
}
export function setMakeFormUnavailableToRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMakeFormUnavailableToRole = value;
}
export function patchMakeFormUnavailableToRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMakeFormUnavailableToRole = patch(_requestConfigMakeFormUnavailableToRole ?? {});
}

let _requestConfigRemoveStudyRole: Partial<AxiosRequestConfig> | null;
export function getRemoveStudyRoleRequestConfig() {
  return _requestConfigRemoveStudyRole;
}
export function setRemoveStudyRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyRole = value;
}
export function patchRemoveStudyRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyRole = patch(_requestConfigRemoveStudyRole ?? {});
}

let _requestConfigRemoveStudyClaimsFromRole: Partial<AxiosRequestConfig> | null;
export function getRemoveStudyClaimsFromRoleRequestConfig() {
  return _requestConfigRemoveStudyClaimsFromRole;
}
export function setRemoveStudyClaimsFromRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyClaimsFromRole = value;
}
export function patchRemoveStudyClaimsFromRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyClaimsFromRole = patch(_requestConfigRemoveStudyClaimsFromRole ?? {});
}

let _requestConfigRemoveRole: Partial<AxiosRequestConfig> | null;
export function getRemoveRoleRequestConfig() {
  return _requestConfigRemoveRole;
}
export function setRemoveRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRole = value;
}
export function patchRemoveRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRole = patch(_requestConfigRemoveRole ?? {});
}

let _requestConfigAddPermission: Partial<AxiosRequestConfig> | null;
export function getAddPermissionRequestConfig() {
  return _requestConfigAddPermission;
}
export function setAddPermissionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddPermission = value;
}
export function patchAddPermissionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddPermission = patch(_requestConfigAddPermission ?? {});
}

let _requestConfigRemovePermission: Partial<AxiosRequestConfig> | null;
export function getRemovePermissionRequestConfig() {
  return _requestConfigRemovePermission;
}
export function setRemovePermissionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemovePermission = value;
}
export function patchRemovePermissionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemovePermission = patch(_requestConfigRemovePermission ?? {});
}